import React from 'react';
import { EvalGtSample } from '../../types';

function Badge({ label, ok }: { label: string; ok: boolean }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        fontSize: 10,
        fontWeight: 600,
        padding: '1px 6px',
        borderRadius: 4,
        background: ok ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)',
        color: ok ? '#16a34a' : '#dc2626',
        border: `1px solid ${ok ? 'rgba(34,197,94,0.35)' : 'rgba(239,68,68,0.35)'}`,
      }}
    >
      {ok ? '✓' : '✗'} {label}
    </span>
  );
}

export function SampleStatusBadges({ sample }: { sample: EvalGtSample }) {
  return (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 4 }}>
      <Badge label="PR" ok={sample.has_pr_inference} />
      <Badge label="PC" ok={sample.has_pc_run_snapshot} />
    </div>
  );
}
